import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'
import { h4, h5 } from '~/theme/utils/typography'

export const Wrapper = styled.section``

export const CrossSellsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
`

export const CrossSellsTitle = styled.h3`
  ${props => h5(props)};
  font-weight: ${({ theme }) => theme.text.fontWeight.semiBold};
  color: ${({ theme }) => theme.colors.gray[900]};

  ${mediaQueryUp('m')} {
    ${props => h4(props)};
    font-weight: ${({ theme }) => theme.text.fontWeight.semiBold};
    color: ${({ theme }) => theme.colors.gray[900]};
  }
`

export const CrossSellsDescription = styled.div`
  font-size: 0.875rem;
  font-weight: ${({ theme }) => theme.text.fontWeight.regular};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.gray[700]};
`

export const CrossSellsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
